<template>
  <page-header-wrapper>
    <a-card :bordered="false">
     <span slot="title" class="card-title">
        <a-button size="small" @click="$router.go(-1)" style="margin-right: 15px;">
          <a-icon type="left" />返回
        </a-button>
        <span>食谱计划日期</span>
      </span>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(planId)" v-hasPermi="['plan:dayInfo:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['plan:dayInfo:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['plan:dayInfo:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['plan:dayInfo:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <a-button type="primary" @click="$refs.createForm.batchAdd(planId)" v-hasPermi="['plan:dayInfo:add']">
          <a-icon type="plus" />批量生成
        </a-button>
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['plan:dayInfo:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['plan:dayInfo:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['plan:dayInfo:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['plan:dayInfo:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDayInfo,listDayInfo, delDayInfo } from '@/api/plan/dayInfo'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {listPlan} from "@/api/cookbook/plan";

export default {
  name: 'DayInfo',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      planId:null,
      selectedRowKeys: [],
      selectedRows: [],
      planOptions: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        planId: null,
        seq: null,
        type: null,
        content: null,
        kilocalorie: null,
        proteinWeight: null,
        proteinRatio: null,
        carbohydrateWeight: null,
        carbohydrateRatio: null,
        fatWeight: null,
        fatRatio: null,
        breakfast: null,
        lunch: null,
        dinner: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /*{
          title: 'id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '是否准备日',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender:function (e) {
            if(e === 0){
              return "否";
            }else if(e === 1) {
              return "是";
            }
          }
        },
        {
          title: '计划标题',
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '排序',
          dataIndex: 'seq',
          ellipsis: true,
          align: 'center'
        },

        /*{
          title: '准备日内容',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '千卡',
          dataIndex: 'kilocalorie',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '蛋白质份量g',
          dataIndex: 'proteinWeight',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '蛋白质含量%',
          dataIndex: 'proteinRatio',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '碳水份量',
          dataIndex: 'carbohydrateWeight',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '碳水含量%',
          dataIndex: 'carbohydrateRatio',
          ellipsis: true,
          align: 'center',
          width: '10%'
        },
        {
          title: '脂肪份量g',
          dataIndex: 'fatWeight',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '脂肪含量%',
          dataIndex: 'fatRatio',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: '早餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]',
          dataIndex: 'breakfast',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '午餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]',
          dataIndex: 'lunch',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: '晚餐食物推荐[{id:21312,name:1231,image:1513,weight:123131,kilocalorie:321231}]',
          dataIndex: 'dinner',
          ellipsis: true,
          align: 'center'
        },*/
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        /*{
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.planId =  this.$route.query.planId
    this.getList()
    this.getPlanOptions()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getPlanOptions() {
      listPlan().then(res => {
        this.planOptions = res.data
      })
    },
    /** 查询食谱计划日期详情列表 */
    getList () {
      this.loading = true
      this.queryParam.planId = this.$route.query.planId
     pageDayInfo(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        planId: undefined,
        seq: undefined,
        type: undefined,
        content: undefined,
        kilocalorie: undefined,
        proteinWeight: undefined,
        proteinRatio: undefined,
        carbohydrateWeight: undefined,
        carbohydrateRatio: undefined,
        fatWeight: undefined,
        fatRatio: undefined,
        breakfast: undefined,
        lunch: undefined,
        dinner: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDayInfo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('plan/dayInfo/export', {
            ...that.queryParam
          }, `食谱计划日期详情_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
